<template>
  <div
    class="app"
    :class="{
      'position-right': config.position == 'right',
      'position-left': config.position == 'left',
      'position-fixed': !display,
    }"
  >
    <div
      class="container"
      :class="{
        'element-hide': !display,
        rtl: dir === 'rtl',
      }"
    >
      <!-- <Header :name="name" :country="country" @toggle="show = !show" /> -->

      <!-- <p>當前路由：{{ route.path }}</p> -->
      <!-- <nav>
        <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link> |
        <router-link to="/gpt">GPT</router-link>
      </nav> -->
      <!-- 
      <div class="params">
        <b>收到or預設參數：</b>
        <p>標題：{{ name }}</p>
        <p>位置：{{ position }}</p>
        <p>寬：{{ width }}</p>
        <p>高：{{ height }}</p>
        <p>底：{{ bottom }}</p>
        <p>左：{{ left }}</p>
        <p>右：{{ right }}</p>
      </div> -->

      <router-view />
    </div>

    <div
      class="toggle"
      :class="{
        'toggle-right': config.position == 'right',
        'toggle-left': config.position == 'left',
        'toggle-hide': display,
        'bubble-show': config.bubble && showBubble,
      }"
    >
      <div class="bubble" v-if="config.bubble && showBubble">
        <img
          class="quotation"
          src="@/assets/images/icons/quotation.png"
          alt="quotation"
        />
        <div class="close" @click="showBubble = false">
          <img src="@/assets/images/icons/close.png" alt="close" />
        </div>

        <p>
          嗨！要了解關於產品規格、比較產品，還是查詢訂單問題，隨時找我就對了！
        </p>
      </div>
      <img
        src="@/assets/images/avatar-genio60.svg"
        alt="genio"
        @keyup.enter="toggleDisplay"
        @click="toggleDisplay"
        tabindex="0"
      />
    </div>
  </div>
</template>

<script>
// import Header from "@/components/layout/Header";
import { languages } from "@/plugins/languages";
export default {
  name: "App",
  // components: { Header },
  data() {
    return { showBubble: true, route: this.$route.path };
  },
  watch: {
    $route(val) {
      this.route = val;
    },
    display(val) {
      if (window.bot_event) {
        window.bot_event.source.postMessage(
          { display: val },
          window.bot_parentUrl
        );
      }
    },
    showBubble(val) {
      if (window.bot_event) {
        window.bot_event.source.postMessage(
          { showBubble: val },
          window.bot_parentUrl
        );
      }
    },
  },

  mounted() {
    if (process.env.NODE_ENV === "production") {
      this.onMessage();
    } else {
      console.log("dev mode.");
      // this.devTest();
    }
    this.route = this.$route;
  },
  methods: {
    onMessage() {
      const vm = this;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: this.chatbot_session_id,
        event_name_ga4: "icon_impression_genio",
        event_category_DL: "genio",
        event_action_DL: "displayed",
        event_label_DL: "icon_impression/genio",
      });
      window.addEventListener("message", (event) => {
        const origin = event.data.parentUrl;
        if (!origin) {
          return;
        }
        window.bot_event = event;
        window.bot_parentUrl = origin;

        const countryId = event.data.countryId.toUpperCase(); //強制大寫
        vm.checkLTR(countryId);

        vm.$store.commit("global/setConfig", event.data);
        vm.$store.dispatch("gpt/initSettingMetas", countryId);

        const lang = languages.includes(countryId) ? countryId : "TW";
        vm.$i18n.locale = lang;

        const oldRoom = event.data.roomId;
        if (oldRoom) {
          vm.$router.push(`/${oldRoom}`);
          vm.toggleDisplay();
          window.bot_event.source.postMessage(
            { display: true },
            window.bot_parentUrl
          );
        }
      });
    },
    devTest() {
      const event = {
        data: {
          parentUrl: "https://asus-widget-test.netlify.app/", // 你的網站
          countryId: "il", // 自訂當前國家/地區
          position: "left", // right or left
          right: "10px", // position = right 時才有作用
          left: "10px", // position = left 時才有作用
          bottom: "60px", // 自訂距離底部位置
          width: "320px", // 自訂寬
          height: "600px", // 自訂高
        },
      };

      const countryId = event.data.countryId.toUpperCase(); //強制大寫
      this.checkLTR(countryId);
      this.$store.commit("global/setConfig", event.data);
      this.$store.dispatch("gpt/initSettingMetas", countryId);

      const lang = languages.includes(countryId) ? countryId : "TW";
      console.log("lang", lang);
      this.$i18n.locale = lang;
    },
    toggleDisplay() {
      this.showBubble = false; // 點擊後關閉 bubble
      this.$store.dispatch("global/toggleDisplay");
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: this.chatbot_session_id,
        event_name_ga4: "icon_click_genio",
        event_category_DL: "genio",
        event_action_DL: "clicked",
        event_label_DL: "icon_click/genio",
      });
    },
    checkLTR(country) {
      const rtlCountries = ["IL", "SA-AR"];
      const dir = rtlCountries.includes(country.toUpperCase()) ? "rtl" : "ltr";
      const dom = document.querySelector(".app .container");

      dom.setAttribute("dir", dir);
      dom.style.setProperty("--direction", dir);
      this.$store.commit("global/setDir", dir);
    },
  },
  computed: {
    // myStyle() {
    //   const width = `width:${this.width};`;
    //   const height = `height:${this.height};`;
    //   const bottom = `bottom:${this.bottom};`;
    //   const right = `right:${this.right};`;
    //   const left = `left:${this.left};`;

    //   return (
    //     width + height + bottom + (this.position === "right" ? right : left)
    //   );
    // },
    display() {
      return this.$store.state.global.display;
    },
    config() {
      return this.$store.state.global.config;
    },
    chatbot_session_id() {
      return this.$store.getters["gpt/chatbot_session_id"];
    },
    dir() {
      return this.$store.state.global.dir;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/all.scss";
p {
  margin: 0;
}
.app {
  position: relative;
  left: 0;
  top: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
  //border: 2px solid red;
  // padding: 15px;
  .container {
    z-index: 1;
    pointer-events: initial;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    // border: 1px solid #eee;
    font-family: Arial, Helvetica, sans-serif;
    // box-shadow: 2px 3px 8px #ccc;
    transition: all 0.4s;
    // background: #fff;
    .params {
      background-color: #eee;
      padding: 10px;
      text-align: left;
      font-size: 12px;
      letter-spacing: 1px;
      p {
        margin: 0;
      }
    }
    nav {
      a {
        font-size: 14px;
        font-weight: bold;
        text-decoration: none;
        color: #2c3e50;
        &.router-link-exact-active {
          color: #42b983;
        }
      }
    }
  }
}
.element-hide {
  transform: scale(0);
  opacity: 0;
}
.position-fixed {
  position: fixed;
}
.position-right {
  .container {
    transform-origin: bottom right;
  }
}
.position-left {
  .container {
    transform-origin: bottom left;
  }
}

.toggle {
  padding: 2px;
  cursor: pointer;
  position: absolute;
  pointer-events: initial;
  // box-shadow: 2px 3px 8px #ddd;
  bottom: 0;
  right: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: -1;
  img {
    width: 100%;
    height: 100%;
  }
}
.toggle-right {
  right: 0;
  bottom: 0;
}
.toggle-left {
  bottom: 0;
  left: 0;
}
.toggle-hide {
  display: none;
}
.bubble-show {
  bottom: 50%;
  transform: translateY(50%);
}
.bubble {
  right: 80px;
  bottom: -30px;
  width: 240px;
  position: absolute;
  backdrop-filter: blur(10px);
  background-color: #ffffff59;
  box-shadow: 0px 5px 20px 0px #27272733;
  color: black;
  border-radius: 20px 4px 20px 10px;
  padding: 15px 30px;
  .quotation {
    width: 16px;
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0px 2px 10px 0px #00000040;
    padding: 4px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  p {
    margin: 0;
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    overflow-y: auto;
    max-height: 80px;
  }
}
.toggle-left .bubble {
  left: 80px;
}
</style>
